import Vue from 'vue'

const enumFilterPlugin = {}

enumFilterPlugin.install = function (Vue, options) {
    Vue.enumFilterMap = function (type, value, lib) {
            //value - значение которое необходимо перевести
            //lib - варианты для мапинга
            let mapResult = ''

            if (type === 'get') {
                //При получении данных
                lib.forEach(item => {
                    if (item.value === value) {
                        mapResult =  item.name
                    }
                })
            }

            if (type === 'send') {
                //При получении данных
                lib.forEach(item => {
                    if (item.value === value) {
                        mapResult = item.value
                    }
                })
            }

            return mapResult
        }
}

Vue.use(enumFilterPlugin)